import { useState } from 'react';
import {
  Typography,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import pMap from 'p-map';
import { Dialog } from '../../components/Dialog';
import * as api from '../../lib/api';

export default function CertifyConfirmation(props) {
  const { handleCertified, handleClose } = props;
  const [fields, setFields] = useState(props.fields);

  return (
    <Dialog
      width="sm"
      title="Certify Fields"
      onCancel={handleClose}
      canSave
      onSave={onSave}
    >
      <Typography variant="body1">
        Are you sure you want to certify the following fields?
      </Typography>
      <List dense>
        {fields.map((field) => (
          <ListItem sx={{ p: 0 }} key={field.aaManagedId}>
            {field.certifying ? (
              <CircularProgress sx={{ mr: 1 }} size={12} color="inherit" />
            ) : null}
            <ListItemText sx={{ m: 0 }} primary={field.fieldName} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );

  async function onSave() {
    try {
      const results = await pMap(fields, certifyOne, { concurrency: 3 });
      handleCertified({ results: results.flat() });
    } catch (error) {
      handleCertified({ error });
    }
  }

  async function certifyOne(field) {
    setFields((current) =>
      current.map((f) => {
        if (f.aaManagedId !== field.aaManagedId) return f;
        return { ...f, certifying: true };
      }),
    );

    return api.certifyFields([field.aaManagedId]).finally(() => {
      setFields((current) =>
        current.filter((f) => f.aaManagedId !== field.aaManagedId),
      );
    });
  }
}
